import { sdk } from 'src/utilities/sdk';
import { decamelizeRequestBody } from 'src/utilities/http-data-casing';

export interface CreateReportOptionalFilters {
  employeeLocationIds: string[];
  employeeEmails?: string[];
}

export interface CreateReportRequest {
  exportName: string;
  uniqueReportName: string;
  startDate: string;
  endDate: string;
  optionalFilters: CreateReportOptionalFilters;
}

export const getCreateReportEndpoint = (corpId: string): string =>
  `/targetedaudiencesgateway/reporting/${corpId}`;

export function createReport(
  corpId: string,
  reportData: CreateReportRequest
): Promise<void> {
  const decamelizedData = decamelizeRequestBody(reportData);

  return sdk.http.post(getCreateReportEndpoint(corpId), decamelizedData);
}
